module.exports = __webpack_public_path__ + "static/media/ns_china.876d5051.png";